/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-icemedx-lib',
  template: `
    <p>
      icemedx-lib works!
    </p>
  `,
  styles: []
})
export class IcemedxLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
